export default __webpack_public_path__ + "static/media/Hero.fc2b7b40.png";